import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import {
  clicked_cta_event,
  getInsideParanthesisText,
  getPostUpdatedDate,
} from '../../../Utils/questionUtils';
import { Comments } from '../../HomePage/Community/styled';
import {
  AnswerSection,
  PregnancyWeekCustomText,
  QuestionRelatedTitle,
  QuestionTitle,
  ShareButton,
  UserQuestionImageSec,
  UserQwrapper,
} from './styled';
import { WhatsappIcon, WhatsappShareButton } from 'next-share';
import { getPublicUrl } from '../../../appconfig';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
import { question_views_add_on } from '../../../Constants/QuestionPage';

export default function UserQuestions(props) {
  const { data, primaryCategory, comments_count, postData } = props;
  const image =
    data?.post?.content?.webpImages?.[0] ||
    data?.post?.content?.newFiles?.[0] ||
    data?.post?.content?.feature_endorsed_doctor?.image;

  const created_at = data?.post?.content?.created_at;
  const pregnancy_week = data?.post?.content?.propertytags?.weekPreg;
  const web_url =
    getPublicUrl() + data?.post?.content?.web_url + '?source=whatsapp-share';
  const [views, setViews] = useState(0);

  const viewsValueData = async () => {
    const { getValues, updateValuesInFireBaseDB } = getFirebaseLiveData();
    const id = data?.post?.object_id;
    let updatedData = await getValues('Views/Question/', id);
    if (updatedData?.views) {
      const obj = {
        [`Views/Question/${id}/views`]: updatedData?.views + 1,
      };
      updateValuesInFireBaseDB(obj);
    } else {
      const obj = {
        [`Views/Question/${id}/views`]: 1,
      };
      updateValuesInFireBaseDB(obj);
    }
    if (updatedData?.views || updatedData?.views == 0) {
      updatedData.views = updatedData?.views + 1;
      setViews(updatedData.views + (id % question_views_add_on));
    } else {
    }
  };
  useEffect(() => {
    viewsValueData();
  }, [data?.post?.object_id]);

  return (
    <UserQwrapper>
      <div className="userquestion">
        <QuestionTitle>
          <QuestionRelatedTitle>{primaryCategory}</QuestionRelatedTitle>
          <p> {getPostUpdatedDate(created_at)}</p>
        </QuestionTitle>
        <PregnancyWeekCustomText>
          <div className="week">{getInsideParanthesisText(pregnancy_week)}</div>
          {views ? (
            <div className="views">
              <img src={images.views_icon} alt="views icons" />
              <span>{views} Views</span>
            </div>
          ) : null}
        </PregnancyWeekCustomText>
        <h1>
          <span className="light">Q:</span> {data?.post?.content?.message}
        </h1>

        {image && (
          // <img
          //     loading="eager"
          //     src={image}
          //     srcSet={`${image}?tr=w-400,q-80 2w, ${image}?tr=w-600,q-80 720w`}
          //     sizes="(max-width: 720px) 2px,720px"
          //     alt=""
          // />
          <UserQuestionImageSec>
            <Image
              src={image}
              alt=""
              quality={90}
              priority={true}
              fill
              sizes="50vw"
            />
          </UserQuestionImageSec>
        )}
      </div>
      <Comments marginLeft="10px" paddingBottom="10px">
        <AnswerSection>
          <img
            className="answerImage"
            loading="lazy"
            src={images.answers}
            alt=""
          />
          <span>{comments_count}</span>
          <span>Answer</span>
        </AnswerSection>
        <ShareButton>
          <WhatsappShareButton
            url={web_url}
            onClick={(e) => {
              clicked_cta_event(
                null,
                'whatsapp',
                'Share',
                '',
                'cta',
                postData?.content_id,
                postData?.object_id,
              );
            }}
          >
            <WhatsappIcon size={22} round />
          </WhatsappShareButton>
          <span>Share</span>
        </ShareButton>
      </Comments>
    </UserQwrapper>
  );
}
